import ACTIONS, { FETCH_STATUS } from "../constants";

// SORT INVOICE_REGISTRY

export const sortInvoiceRegistryRequest = (state) => ({
  type: ACTIONS.SORT_INVOICE_REGISTRY_CALL,
  payload: state,
});

export const sortInvoiceRegistryRequestAttempt = {
  pending: {
    type: ACTIONS.SORT_INVOICE_REGISTRY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_INVOICE_REGISTRY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_INVOICE_REGISTRY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// GET INVOICE_REGISTRY

export const getInvoiceRegistryRequest = (state) => ({
  type: ACTIONS.INVOICE_REGISTRY_CALL,
  payload: state,
});

export const getInvoiceRegistryAttempt = {
  pending: {
    type: ACTIONS.INVOICE_REGISTRY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.INVOICE_REGISTRY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.INVOICE_REGISTRY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// CREATE INVOICE_RGISTRY

export const createInvoiceRegistryRequest = (state) => ({
  type: ACTIONS.CREATE_INVOICE_REGISTRY_CALL,
  payload: state,
});

export const createInvoiceRegistryAttempt = {
  pending: {
    type: ACTIONS.CREATE_INVOICE_REGISTRY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_INVOICE_REGISTRY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_INVOICE_REGISTRY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// UPDATE INVOICE_REGISTRY

export const updateInvoiceRegistryRequest = (state) => ({
  type: ACTIONS.UPDATE_INVOICE_REGISTRY_CALL,
  payload: state,
});

export const updateInvoiceRegistryAttempt = {
  pending: {
    type: ACTIONS.UPDATE_INVOICE_REGISTRY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_INVOICE_REGISTRY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_INVOICE_REGISTRY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// DELETE INVOICE_REGISTRY

export const deleteInvoiceRegistryRequest = (state) => ({
  type: ACTIONS.DELETE_INVOICE_REGISTRY_CALL,
  payload: state,
});

export const deleteInvoiceRegistryAttempt = {
  pending: {
    type: ACTIONS.DELETE_INVOICE_REGISTRY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_INVOICE_REGISTRY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_INVOICE_REGISTRY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

// FLAG INVOICE_REGISTRY

export const updateInvoiceRegistryFlagRequest = (state) => ({
  type: ACTIONS.INVOICE_REGISTRY_FLAG_CALL,
  payload: state,
});

export const updateInvoiceRegistryFlagAttempt = {
  pending: {
    type: ACTIONS.INVOICE_REGISTRY_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.INVOICE_REGISTRY_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.INVOICE_REGISTRY_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
